import "./splash.scss";
import nflix from "./assets/nflix_logo.png";
import mh from "./assets/logo.png";
import hashtag from "./assets/hashtag.png";
import arrow from "./assets/arrow.png";
import video from "../../assets/videos/splash_glitch.mp4";
import { motion } from "framer-motion";

const Splash = () => {
  return (
    <section className="section splash">
      <motion.video
        playsInline
        autoPlay
        muted
        loop
        className="bg-video"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <source src={video} type="video/mp4" />
      </motion.video>
      <motion.div
        className="top-bar"
        initial={{ opacity: 0, y: -200 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <img src={nflix} alt="Netflix" className="nflix" />
        <img src={mh} alt="Money Heist Part 5" className="mh" />
      </motion.div>
      <motion.div
        className="body-content"
        initial={{ opacity: 0, y: 200 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <img src={hashtag} alt="#HaveAHeistDay" />
        <p>
          To launch the final season of Money Heist in Indonesia, we coordinated
          a series of stunts to look like the Professor and the gang were taking
          over Jakarta. Throughout the campaign, we got fans guessing where they
          would hit next. Each stunt was signed off with the cryptic
          “#HaveAHeistDay”.
        </p>
      </motion.div>
      <div className="scroll">
        <p>scroll down</p>
        <img src={arrow} alt="Arrow Down" />
      </div>
    </section>
  );
};

export default Splash;
